import {
  ADE_KILLSWITCH_REQUEST_ASYNC,
  ADE_KILLSWITCH_UPDATE,
  DEL_LOGO_REQUEST,
  GENERAL_SETTINGS_REQUEST_ASYNC,
  UPDATE_GENERAL_SETTINGS_REQUEST,
} from './constants'

const getGeneralSettings = () => ({
  type: GENERAL_SETTINGS_REQUEST_ASYNC.INITIATE,
})
export const getGeneralSettingsSuccess = (data) => ({
  type: GENERAL_SETTINGS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getGeneralSettingsError = (error) => ({
  type: GENERAL_SETTINGS_REQUEST_ASYNC.ERROR,
  error,
})
const getGeneralSettingsCancel = () => ({
  type: GENERAL_SETTINGS_REQUEST_ASYNC.CANCEL,
})

const updateGeneralSettings = (data) => ({
  type: UPDATE_GENERAL_SETTINGS_REQUEST.INITIATE,
  payload: data,
})
export const updateGeneralSettingsSuccess = (data) => ({
  type: UPDATE_GENERAL_SETTINGS_REQUEST.SUCCESS,
  payload: { data },
})
export const updateGeneralSettingsError = (error) => ({
  type: UPDATE_GENERAL_SETTINGS_REQUEST.ERROR,
  error,
})
const updateGeneralSettingsCancel = () => ({
  type: UPDATE_GENERAL_SETTINGS_REQUEST.CANCEL,
})

const getAdeKillswitch = () => ({
  type: ADE_KILLSWITCH_REQUEST_ASYNC.INITIATE,
})
export const getAdeKillswitchSuccess = (data) => ({
  type: ADE_KILLSWITCH_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getAdeKillswitchError = (error) => ({
  type: ADE_KILLSWITCH_REQUEST_ASYNC.ERROR,
  error,
})
const getAdeKillswitchCancel = () => ({
  type: ADE_KILLSWITCH_REQUEST_ASYNC.CANCEL,
})

const updateAdeKillswitch = (data) => ({
  payload: { data },
  type: ADE_KILLSWITCH_UPDATE.INITIATE,
})
export const updateAdeKillswitchSuccess = () => ({
  type: ADE_KILLSWITCH_UPDATE.SUCCESS,
})
export const updateAdeKillswitchError = (error) => ({
  type: ADE_KILLSWITCH_UPDATE.ERROR,
  error,
})

const delCompanyLogo = () => ({ type: DEL_LOGO_REQUEST.INITIATE })
export const delCompanyLogoSuccess = () => ({ type: DEL_LOGO_REQUEST.SUCCESS })
export const delCompanyLogoError = (error) => ({
  type: DEL_LOGO_REQUEST.ERROR,
  error,
})

export default {
  // to props
  getAdeKillswitch,
  getAdeKillswitchCancel,
  updateAdeKillswitch,
  updateAdeKillswitchSuccess,
  getGeneralSettings,
  getGeneralSettingsCancel,
  updateGeneralSettings,
  updateGeneralSettingsCancel,
  delCompanyLogo,
}
